import { useEffect, useState } from "react";
import { api } from "@/lib/apiClient";
import { Button } from "@/components/ui/Button";
import { Modal } from "@/components/ui/Modal";
import type { PlannerCustomRow } from "@/types/camping";

export interface PlannerCustomRowModalProps {
  open: boolean;
  onClose: () => void;
  onSaved: () => void;
}

export function PlannerCustomRowModal({ open, onClose, onSaved }: PlannerCustomRowModalProps) {
  const [label, setLabel] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!open) return;
    setLabel("");
    setError(null);
  }, [open]);

  async function handleSave() {
    if (!label.trim()) {
      setError("Bitte einen Zeilennamen eingeben.");
      return;
    }
    setSaving(true);
    setError(null);
    try {
      await api.post<PlannerCustomRow>("/api/v1/planner/custom-rows", { label: label.trim() });
      onSaved();
      onClose();
    } catch (e) {
      setError(e instanceof Error ? e.message : "Speichern fehlgeschlagen.");
    } finally {
      setSaving(false);
    }
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Zeile hinzufügen"
      description="Eigene Planungszeile ohne Stellplatzbezug – Einträge per Rechtsklick auf die Zeile anlegen."
      size="md"
      footer={
        <div className="ml-auto flex gap-2">
          <Button type="button" variant="ghost" onClick={onClose}>
            Abbrechen
          </Button>
          <Button type="button" loading={saving} onClick={() => void handleSave()}>
            Hinzufügen
          </Button>
        </div>
      }
    >
      <label className="block text-sm">
        <span className="mb-1 block font-medium text-label">Zeilenname</span>
        <input
          className="eh-input w-full"
          value={label}
          onChange={(e) => setLabel(e.target.value)}
          placeholder="z. B. Veranstaltungen, Werkstatt"
          autoFocus
        />
      </label>
      {error ? <p className="mt-3 text-sm text-status-red">{error}</p> : null}
    </Modal>
  );
}
